import { useScrollReveal } from '@/hooks/useScrollAnimations';

const logos = [
  { src: '/images/clients/albarka.jpg', name: 'Albarka School' },
  { src: '/images/clients/adabelle.jpg', name: 'Adabelle Gold' },
  { src: '/images/clients/al-awwal.jpg', name: 'Al-Awwal Islamic College' },
  { src: '/images/clients/aran-orin.jpg', name: "Aran-Orin St. Paul's" },
  { src: '/images/clients/jubilee.jpg', name: 'Jubilee Schools' },
  { src: '/images/clients/bethel.jpg', name: 'Bethel School' },
  { src: '/images/clients/bhum-schools.jpg', name: 'BHUM Schools' },
  { src: '/images/clients/blessed-child.jpg', name: 'Blessed Child' },
  { src: '/images/clients/bright-future.jpg', name: 'Bright Future' },
  { src: '/images/clients/fgc-logo.jpg', name: 'FGC' },
  { src: '/images/clients/fgc-odi.jpg', name: 'FGC Odi' },
  { src: '/images/clients/galad-school.jpg', name: 'Galad School' },
  { src: '/images/clients/hauwa-goni.jpg', name: 'Hauwa Goni College' },
  { src: '/images/clients/jasola.jpg', name: 'Jasola School' },
  { src: '/images/clients/minaret-islamic.jpg', name: 'Minaret Islamic' },
  { src: '/images/clients/mount-carmel.jpg', name: 'Mount Carmel' },
  { src: '/images/clients/offspring.jpg', name: 'Offspring School' },
  { src: '/images/clients/promise-school.jpg', name: 'Promise School' },
  { src: '/images/clients/st-charles.jpg', name: 'St. Charles' },
  { src: '/images/clients/universal-royal.jpg', name: 'Universal Royal Lead' },
];

const ClientLogos = () => {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="py-20 bg-muted/50 overflow-hidden" aria-label="Our Clients">
      <div ref={ref} className="container mx-auto px-4">
        <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <span className="text-primary font-semibold text-sm uppercase tracking-widest">Our Clients</span>
          <h2 className="text-3xl md:text-4xl font-bold font-display mt-3 text-foreground">Trusted by Schools & Organizations</h2>
          <p className="text-muted-foreground mt-3 max-w-lg mx-auto">Partnering with leading institutions across Nigeria to deliver exceptional branding.</p>
        </div>
      </div>

      {/* Infinite marquee - Row 1 */}
      <div className="relative mb-4">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-muted/50 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-muted/50 to-transparent z-10" />
        <div className="flex animate-marquee">
          {[...logos, ...logos, ...logos].map((logo, i) => (
            <div
              key={i}
              className="flex-shrink-0 mx-3 w-20 h-20 bg-card rounded-xl border border-border flex items-center justify-center p-2 grayscale hover:grayscale-0 transition-all duration-500 hover:shadow-lg hover:border-primary/30 hover:scale-110"
            >
              <img src={logo.src} alt={logo.name} className="w-full h-full object-contain" loading="lazy" />
            </div>
          ))}
        </div>
      </div>

      {/* Row 2 - reverse direction */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-muted/50 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-muted/50 to-transparent z-10" />
        <div className="flex animate-marquee" style={{ animationDirection: 'reverse', animationDuration: '40s' }}>
          {[...logos.slice(10), ...logos.slice(0, 10), ...logos.slice(10), ...logos.slice(0, 10), ...logos].map((logo, i) => (
            <div
              key={i}
              className="flex-shrink-0 mx-3 w-20 h-20 bg-card rounded-xl border border-border flex items-center justify-center p-2 grayscale hover:grayscale-0 transition-all duration-500 hover:shadow-lg hover:border-primary/30 hover:scale-110"
            >
              <img src={logo.src} alt={logo.name} className="w-full h-full object-contain" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
